import dispatcher from "../dispatcher";
import {doApiCall} from "../apicommunication"

export function signIn(email, password, cb?){
    doApiCall("core/accounts/portallogin", {"email": email, "password": password}, function (result) {
        dispatcher.dispatch({
            type: "SIGN_IN",
            userId : result.userid,
            authStr: result.authstr
        });
        if(cb !== undefined)
            cb();
    });
}

export function sessionSignIn(cb?){
    doApiCall("core/accounts/sessionlogin", {}, function (result) {

        dispatcher.dispatch({
            type: "SIGN_IN",
            userId : result.userid,
            authStr: result.authstr
        });
        if(cb !== undefined)
            cb();

    }, true);
}